import type { UpdateCandidateResumeRequest } from '@entities/candidates';
import type { CandidateResumeEditValues } from '../types';

const normalizeText = (value: string) => {
  const normalizedValue = value.trim();

  return normalizedValue || null;
};

const normalizeNumber = (value: string) => {
  const normalizedValue = value.trim();

  return normalizedValue ? Number(normalizedValue) : null;
};

const normalizeIds = (values: string[]) => values.map(value => Number(value));

export const getCandidateResumeUpdateRequest = (
  values: CandidateResumeEditValues
): UpdateCandidateResumeRequest => ({
  activitySphereIds: normalizeIds(values.activitySphereIds),
  desiredJob: normalizeText(values.desiredJob),
  skillIds: normalizeIds(values.skillIds),
  experience: normalizeText(values.experience),
  salary: normalizeNumber(values.salary),
  currencyId: normalizeNumber(values.currencyId),
  paymentPeriodId: normalizeNumber(values.paymentPeriodId),
  scheduleWorkIds: normalizeIds(values.scheduleWorkIds),
  employmentTypeIds: normalizeIds(values.employmentTypeIds),
});
